import commonApi from './CommonApi.js';

export default {
	getByUserCommentId: async (parameters) => {
		return await commonApi().get('/v1/userComments/edit', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (viewModel) => {
		return await commonApi().post('/v1/userComments', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/userComments', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/userComments', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}